import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { COLORS } from "colors/color";

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: 30,
  fontFamily: "Poppins",
  fontWeight: "bold",
  color: COLORS.title_color,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));
export const FieldTypography = styled(Typography)(({ theme }) => ({
  color:COLORS.fieldTitle_color,
  fontSize: "13px",
  fontFamily: "Poppins",
  fontWeight: 500,
  // marginTop: theme.spacing(4),
  marginBottom: theme.spacing(1),
}));